/**
 * SGKE363A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SupplyresumptionResultInfo {

    /**
     * 供給地点特定番号
     */
    suppntSpno?: string;
    /**
     * 供給停止再開履歴番号
     */
    supplystopresumptionRrkno?: string;
    /**
     * 供給停止再開地点情報管理_更新通番号
     */
    supplystopresumptionPointinfomngUpdatesequencenumber?: string;
    /**
     * 請求先名
     */
    visitName?: string;
    /**
     * 供給停止再開結果区分コード
     */
    supplystopresumptionResultDivcd?: string;
    /**
     * 供給再開日付
     */
    supplyresumptionDate?: string;
    /**
     * 供給再開時刻
     */
    supplyresumptionHms?: string;
    /**
     * 供給停止再開作業種別コード
     */
    supplystopresumptionWorkClscode?: string;
    /**
     * 供給再開作業担当者ユーザID
     */
    supplyresumptionWorktntshUserid?: string;
    /**
     * 供給再開作業担当者名
     */
    supplyresumptionWorkTantoshaname?: string;
    /**
     * エネルギー種別コード
     */
    energyClscode?: string;
    /**
     * 作業場所コード
     */
    workPlaceCode?: string;
    /**
     * メーターガス栓閉止フラグ
     */
    meterGassenShutoffflag?: boolean;
    /**
     * 作業者メモ
     */
    sgyshMemo?: string;
    /**
     * 供給停止年月日
     */
    supplystopYearmonthdate?: string;
    /**
     * 供給停止時刻
     */
    supplystopHms?: string;
    /**
     * 停止時指針
     */
    duringstopShishin?: number;
    /**
     * 停止時使用量
     */
    duringstopEmpamt?: number;
    /**
     * マイコンメーター点滅フラグ
     */
    microcontrollermeterFlashingFlg?: string;
    /**
     * メーター休止フラグ
     */
    meterPauseFlg?: string;
    /**
     * 閉止不能理由コード
     */
    shutoffFunoRsncod?: string;
    /**
     * 供給停止時処置フラグ
     */
    supplysuspensiontimeTreatmentFlg?: string;
    /**
     * エフ取付フラグ
     */
    efuInstallationFlg?: string;
    /**
     * 供給停止書投函場所コード
     */
    supplystopdocumentPostingLocationcode?: string;
    /**
     * 供給再開種別
     */
    supplyresumptionClsfy?: string;
    /**
     * 変更前供給停止予定日付
     */
    bfSupplystopScddt?: string;
    /**
     * 変更後供給停止予定日付
     */
    afSupplystopScddt?: string;
    /**
     * 変更前供給再開予定日
     */
    bfSupplyresumptionPlndate?: string;
    /**
     * 変更後供給再開予定日
     */
    afSupplyresumptionPlndate?: string;
    /**
     * 変更後供給再開予定時間帯
     */
    afSupplyresumptionYtitimez?: string;
    /**
     * 供給停止作業担当ユーザID
     */
    supplystopWorkchargeUserid?: string;
    /**
     * 供給停止作業担当者名
     */
    supplystopWorkTantoshaname?: string;
    /**
     * マイコンメーター有無フラグ
     */
    microcontrollermeterUmuFlg?: boolean;
    /**
     * メーター外観異常フラグ
     */
    meterExteriorAbnormalflag?: boolean;
    /**
     * メーターガス栓異常フラグ
     */
    meterGassenAbnormalflag?: boolean;
    /**
     * マイコンメーターテスト遮断異常フラグ
     */
    microcontrollermeterTestblockAbnormalflag?: boolean;
    /**
     * マイコンメーター復帰異常フラグ
     */
    microcontrollermeterReturnAbnormalflag?: boolean;
    /**
     * 動止確認漏洩検査可否フラグ
     */
    operationcheckLeaktestKahiflg?: boolean;
    /**
     * メーター指針動止確認コード
     */
    meterShishinstartandstopConfirmationcode?: string;
    /**
     * メーター休止措置フラグ
     */
    meterPauseSochiflag?: boolean;
    /**
     * 点検業務引継先フラグ
     */
    inspectiontaskTakeovertoFlg?: boolean;
    /**
     * 点検業務引継先コード
     */
    inspectiontaskTakeovertoCode?: string;
    /**
     * 再開時指針
     */
    onresumptionShishin?: number;
    /**
     * 非安全機器周知フラグ
     */
    unsafeDeviceNoticeflag?: boolean;
    /**
     * 点火試験済フラグ
     */
    lightingExaminedFlg?: boolean;
    /**
     * 署名区分
     */
    signatureDiv?: string;
    /**
     * 署名
     */
    signature?: string;
}

